export default __webpack_public_path__ + "static/media/file-paperclip-icon.d78d8c41.svg";